import { Col, Input, Row, Select, Cascader } from "antd";
import Icon from 'common/components/IconFont';
import * as React from "react";
import * as intl from 'react-intl-universal';
import statics from 'common/statics';
import { languages } from "common/i18n";
import ControlApi from 'common/api/control';
const { Option } = Select;
const InputGroup = Input.Group;

export default class Address extends React.Component<any> {
    state: any = {
        buildingSelect: 'building',
        roomSelect: 'room',
        buildingInput: '',
        roomInput: '',
        district: '',
        street: '',
        community: '',
        asyncOptions: [],
        area: this.props.value.area || [],
        isEn: languages.getDefault() === 'en-US',
    };
    private mounted: boolean;

    enFields: any = {
        'building': 'Building',
        'tower': 'Tower',
        'room': 'Room',
        'flat': 'Flat',
        'unit': 'Unit'
    };

    componentDidMount() {
        this.mounted = true;
        const { options } = this.props;
        if (options) {
            this.setState({ asyncOptions: options });
        } else {
            statics.get('area', (asyncOptions: Array<any> = []) => this.setState({ asyncOptions }));
        }
        this.initAddress();
    }

    initAddress = () => {
        const { value: { detailAddress={} } } = this.props;
        const { buildingSelect, buildingInput, roomSelect, roomInput, district, street, community } = this.formatValue(detailAddress);
        this.setState({
            buildingSelect, buildingInput, roomSelect, roomInput, district, street, community
        });
    }

    UNSAFE_componentWillReceiveProps({ options, disabled }: any) {
        const { asyncOptions } = this.state;
        if (this.mounted) {
            if (!asyncOptions.length && options && options.length) this.setState({ asyncOptions: options });
        }
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    // 值变化
    changeHandler = (index: 0 | 1, inputValue: string, innerKey: string, wrapperKey: any) => {
        const { onChange, value = {} } = this.props;
        const { buildingInput, roomInput, buildingSelect, roomSelect } = this.state;
        const copyValue = JSON.parse(JSON.stringify(value));
        const { area = [], detailAddress = {} } = copyValue;
        if (detailAddress && detailAddress[wrapperKey] && index === 1) {
            detailAddress[wrapperKey][innerKey] = inputValue;
        } else {
            detailAddress[wrapperKey] = { [innerKey]: inputValue };
        }
        if (wrapperKey === 'buildingSelect') {
            index === 1 ? this.setState({ buildingInput: inputValue }) :
            detailAddress[wrapperKey] = { [buildingSelect]: buildingInput };
        } else if (wrapperKey === 'roomSelect') {
            index === 1 ? this.setState({ roomInput: inputValue }) :
            detailAddress[wrapperKey] = { [roomSelect]: roomInput };
        }
        wrapperKey === 'inputValue' && this.setState({ [innerKey]: inputValue });
        onChange && onChange({detailAddress,area});
    };

    // 地址
    formatValue = (value: any = {}) => {
        const { buildingSelect: buildingData, roomSelect: roomData, inputValue = {} } = value;
        const building = [buildingData && Object.keys(buildingData)[0], buildingData && Object.values(buildingData)[0]];
        const room = [roomData && Object.keys(roomData)[0], roomData && Object.values(roomData)[0]];
        let buildingSelect: any = building[0] ? building[0] : 'building';
        let buildingInput: any = building[1] ? building[1] : '';
        let roomSelect: any = room[0] ? room[0] : 'room';
        let roomInput: any = room[1] ? room[1] : '';
        let district = inputValue.district || '';
        let street = inputValue.street || '';
        let community = inputValue.community || '';
        return { buildingSelect, buildingInput, roomSelect, roomInput, district, street, community };
    }

    // 国家地区变化
    countryChangeHandler = (val: any, selectedOptions: any) => {
        this.mounted && this.setState({ area: val });
        const { value, onChange } = this.props;
        value.area = val;
        if (onChange) onChange(value);
    };

    // 失焦
    blurHandler = (key?: string, wrapperKey?: string) => {
        const { value = {}, onBlur, onChange } = this.props;
        onBlur ? onBlur(value) : onChange && onChange(value);
    };

    selectChange = (selectvalue: any, key: string) => {
        this.setState({ [key]: selectvalue }, () => {
            this.changeHandler(0, null, selectvalue, key);
        });
    };

    // 首字母转大写
    fistLetterUpper = (value: any) => {
        return value.charAt(0).toUpperCase() + value.slice(1);
    };

    getStaticDisplay = () => {
        const { value: { area, detailAddress={} } } = this.props;
        if (!area) return '-';
        const { isEn, asyncOptions } = this.state;
        const { buildingSelect, buildingInput, roomSelect, roomInput, district, street, community } = this.formatValue(detailAddress);
        const addresFields: any = {
            countryDisplay: this.getTreeDesc(asyncOptions,area) || '-',
            district: `${district || '-'} ${intl.get('Global.District')}`,
            street: `${street || '-'} ${intl.get('Global.Street')}`,
            community: `${community || '-'}`,
            buildingSelect: `(${intl.get(`Global.${this.fistLetterUpper(buildingSelect)}`)}) ${buildingInput || '-'}`,
            roomSelect: `(${intl.get(`Global.${this.fistLetterUpper(roomSelect)}`)}) ${roomInput || '-'}`
        };
        let res = ['countryDisplay','district', 'street', 'community', 'buildingSelect', 'roomSelect'];
        isEn && res.reverse();
        return <span style={{wordBreak: 'break-all'}}>{(!area.length && !district && !street && !community && !buildingInput && !roomInput) ? '-' : res.map((item: string) => addresFields[item]).join(',')}</span>;
    }

    // 国家地区三级联动
    loadCountry = async (selectedOptions: any) => {
        let provinceList = [];
        const targetOption = selectedOptions[selectedOptions.length - 1];
        targetOption.loading = true;
        statics.get('area', async (countryList: Array<any> = []) => {
            if (selectedOptions.length === 1) {
                const selectCountry = countryList.find((item: any) => item.value === targetOption.value);
                provinceList = await ControlApi.province({ lang: languages.getDefault(), country_id: selectCountry.id });
                targetOption.children = provinceList;
            } else if (selectedOptions.length === 2) {
                const cityList = await ControlApi.city({ lang: languages.getDefault(), province_id: targetOption.value });
                targetOption.children = cityList;
            }
            targetOption.loading = false;
            this.setState({
                asyncOptions: [...this.state.asyncOptions]
            });
        });
    };

    // 兼容以前的数据
    handlerValue = () =>{
        const {value: { area }} =this.props;
        return typeof area === 'string' ? [area] : (area && !!area[0]) ? area : undefined;
    };

    loadDataHandler = async (selectedOptions: any) => {
        this.setState({ selectedOptions: selectedOptions });
        const { loadCountry, loadData } = this.props;
        if (loadCountry) {
            await this.loadCountry(selectedOptions);
        } else if (loadData) {
            loadData(selectedOptions);
        }
    };

    getTreeDesc = (location: any[], values: any[] = []) => {
        let ret: any[] = [];
        const getStaticView = (items: any[], deepIndex: number) => {
            const option = items.find((item) => item.value === values[deepIndex]);
            if (option) {
                ret.push(option.label);
                Array.isArray(option.children) && getStaticView(option.children, deepIndex + 1);
            } else if (values[deepIndex]) {
                ret.push(values[deepIndex]);
                values[deepIndex + 1] && getStaticView([], deepIndex + 1);
            }
        };
        getStaticView(location, 0);
        return ret.join('/');
    };

    render() {
        const { placeholder, disabled, size, changeOnSelect, formatFn, staticView, displayRender, value: {detailAddress={}} } = this.props;
        const { isEn, area, asyncOptions } = this.state;
        const { buildingSelect, buildingInput, roomSelect, roomInput, district, street, community } = this.formatValue(detailAddress);
        return (staticView && disabled) ? this.getStaticDisplay()
        : <InputGroup className='address' style={{ display: 'flex', flexDirection: isEn ? 'column-reverse': 'column' }}>
                <Cascader value={this.handlerValue()}
                         options={formatFn ? formatFn(asyncOptions) : asyncOptions}
                         placeholder={placeholder}
                         loadData={this.loadDataHandler}
                         disabled={disabled}
                         size={size}
                         defaultValue={area}
                         changeOnSelect={changeOnSelect}
                         onChange={this.countryChangeHandler}
                         displayRender={displayRender}
                         suffixIcon={<Icon className="anticon-caret_down" />}>
                </Cascader>
                <Row style={isEn ? {display: 'flex', flexDirection: 'row-reverse',marginTop: 5} : { display: 'flex' }}>
                    <Col className='address-col'>
                        <Input placeholder={intl.get('Global.District')}
                            value={district || ''}
                            onBlur={() => this.blurHandler('district', 'inputValue')}
                            onChange={(e: any) => this.changeHandler(1, e.target.value, 'district', 'inputValue')} />
                        <span className='label'>{intl.get('Global.District')},</span>
                    </Col>
                    <Col className='address-col'>
                        <Input placeholder={intl.get('Global.Street')}
                            value={street || ''}
                            onBlur={() => this.blurHandler('street', 'inputValue')}
                            onChange={(e: any) => this.changeHandler(1, e.target.value, 'street', 'inputValue')} />
                        <span className='label'>{intl.get('Global.Street')},</span>
                    </Col>
                    <Col className='address-col'>
                        <Input placeholder={intl.get('Global.Community')}
                            value={community || ''}
                            onBlur={() => this.blurHandler('community', 'inputValue')}
                            onChange={(e: any) => this.changeHandler(1, e.target.value, 'community', 'inputValue')} />
                        <span className='label'>,</span>
                    </Col>
                </Row>
                <Row style={isEn ? { display: 'flex', flexDirection: 'row-reverse', justifyContent: 'flex-end' } : { display: 'flex', marginTop: 5 }}>
                    <Col span={11}>
                        <InputGroup className='address-col' compact>
                            <Select
                                style={{ width: 130, marginRight: 5 }}
                                defaultValue='building'
                                value={buildingSelect}
                                onSelect={(v: any) => this.selectChange(v, 'buildingSelect')}
                                dropdownClassName='set-index' suffixIcon={<Icon className="anticon-caret_down" />}>
                                <Option value='building'>{intl.get('Global.Building')}</Option>
                                <Option value='tower'>{intl.get('Global.Tower')}</Option>
                            </Select>
                            <Input
                                placeholder={intl.get(`Global.${this.fistLetterUpper(buildingSelect)}`)}
                                value={buildingInput}
                                onChange={(e: any) => this.changeHandler(1, e.target.value, buildingSelect, 'buildingSelect')}
                                onBlur={() => this.blurHandler('buildingInput', 'buildingSelect')} />
                        </InputGroup>
                    </Col>
                    <Col span={1}>
                        <span className='label'>{','}</span>
                    </Col>
                    <Col span={11}>
                        <InputGroup className='address-col' compact>
                            <Select
                                style={{ width: 130, marginRight: 5 }}
                                defaultValue='room'
                                value={roomSelect}
                                dropdownClassName='set-index'
                                onSelect={(v: any) => this.selectChange(v, 'roomSelect')}
                                suffixIcon={<Icon className="anticon-caret_down" />}>
                                <Option value='room'>{intl.get('Global.Room')}</Option>
                                <Option value='flat'>{intl.get('Global.Flat')}</Option>
                                <Option value='unit'>{intl.get('Global.Unit')}</Option>
                            </Select>
                            <Input
                                placeholder={intl.get(`Global.${this.fistLetterUpper(roomSelect)}`)}
                                value={roomInput}
                                onChange={(e: any) => this.changeHandler(1, e.target.value, roomSelect, 'roomSelect')}
                                onBlur={() => this.blurHandler('roomInput', 'roomSelect')} />
                        </InputGroup>
                    </Col>
                </Row>
        </InputGroup>;
    }
}
